module.exports = __webpack_public_path__ + "static/media/20170806_35day_1779AT.016240d6.jpg";